import { PlatformKey } from './platformConfig';

export function canonicalFrom(platform: PlatformKey, raw: string): string {
  const input = raw || '';
  const decodeHrefParam = (s: string) => {
    const m = s.match(/[?&]href=([^&]+)/i);
    return m ? decodeURIComponent(m[1]) : s;
  };

  // YouTube
  if (platform === 'youtube' || platform === 'youtube-shorts') {
    // prefer watch?v=… over /embed/…
    const id =
      input.match(/youtube\.com\/embed\/([^?&]+)/)?.[1] ||
      input.match(/[?&]v=([^&]+)/)?.[1] ||
      input.match(/youtu\.be\/([^?&]+)/)?.[1] ||
      input.match(/shorts\/([^?&]+)/)?.[1];
    return id ? `https://www.youtube.com/watch?v=${id}` : input;
  }

  // Facebook (plugins URL → original post/reel/video URL)
  if (platform === 'facebook') {
    // if it's the plugins URL, extract the href param
    if (/facebook\.com\/plugins\//i.test(input)) {
      return decodeHrefParam(input);
    }
    return input;
  }

  // Instagram
  if (platform === 'instagram') {
    // strip params; keep /p/... or /reel/... permalink
    const m = input.match(/https?:\/\/(?:www\.)?instagram\.com\/(p|reel)\/[^/?#]+/i);
    return m ? m[0] : input.split('?')[0];
  }

  // Twitter/X
  if (platform === 'twitter') {
    const m = input.match(/https?:\/\/(?:twitter\.com|x\.com)\/[^/]+\/status\/\d+/i);
    return m ? m[0] : input;
  }

  // TikTok (best effort: if we only have embed v2 id, we can't recover @user; fall back)
  if (platform === 'tiktok') {
    const id = input.match(/tiktok\.com\/embed\/v2\/(\d+)/)?.[1];
    // if you store the original post URL elsewhere, prefer that.
    return id ? `https://www.tiktok.com/@_/video/${id}` : input;
  }

  // LinkedIn
  if (platform === 'linkedin') {
    // if it's an embed url, try to surface the feed url; otherwise just return as-is
    const m = input.match(/urn:li:share:(\d+)/);
    return m ? `https://www.linkedin.com/feed/update/urn:li:share:${m[1]}` : input;
  }

  // link/newsletter (already canonical-ish)
  return input;
}


